/************
 * Model Class
 * File Name ...: datarecord.components.ts
 * Generated By : ianday on 4/30/25
 * Date ........: 4/30/25
 /************/
import {ValidationResult} from './validation-result';

export class DataRecord {
    id: string;
    description: string;

    constructor(id: string, description: string) {
        this.id = id;
        this.description = description;
    }
}

export class DataRecordInt {
    id: number;
    description: string;

    constructor(id: number, description: string) {
        this.id = id;
        this.description = description;
    }
}
